import React from "react";
import ReverseShipmentQuantities from "./ReverseShipmentQuantities";

const reverseShipmentQuantities = {
  path: "reverse-shipment-quantities",
  sideNav: {
    group: 4,
    order: 70,
    label: "Reverse Shipment Qty",
    entityType: ["systemAdmin"],
    allowedRole: ["systemAdmin"],
    auth: ["authenticated"],
  },
  route: {
    index: {
      element: <ReverseShipmentQuantities />,
      allowedRole: "all",
      entityType: "all",
      auth: ["authenticated"],
    },
  },
};

export default reverseShipmentQuantities;
